var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"stickySidebar"},[_vm._t("default",null,{"columns":_vm.slotConfig.columns,"modules":_vm.modules,"tag":_vm.slotConfig.tag})],2)}
var staticRenderFns = []

export { render, staticRenderFns }